import $ from 'jquery';
import TweenMax, { TimelineMax } from 'TweenMax';
import ScrollMagic from 'scrollmagic';
import 'animation.gsap';
import 'debug.addIndicators';

export default () => {
  const ctrl = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: 'onLeave',
      reverse: false
    }
  });

  $('.fade-section').each(function anim() {
    const tween = TweenMax.from($(this), 0.6, {yPercent: 50, 'opacity': '0'}, .2 );
    new ScrollMagic.Scene({
        triggerElement: this,
        offset: -1000
      }).setTween(tween).addTo(ctrl);
  })
}



// WEBPACK FOOTER //
// app/scripts/components/animation.js